var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"cmd-saving",attrs:{"role":"status"}},[(_vm.busy)?[_c('i',{staticClass:"el-icon-loading",attrs:{"aria-hidden":"true"}}),_vm._v(" "+_vm._s(_vm.label || _vm.defaultLabel))]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }